import { Component, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'
let fuse = new Fuse([], {})

library.add(faTrashAlt, faEdit)

@Component({
	components: {
		Loader,
	},
})
export default class ContentTags extends Vue {
	loading = false
	modalLoading = false
	options = [] as Array<any>
	filter = ''

	form = {
		id: '',
		name: '',
		desc: '',
		wp_id: '',
	}

	get filteredOptions() {
		// @ts-ignore
		return this.filter.length
			? fuse.search(this.filter).map(({ item }) => item)
			: this.options
	}

	async init() {
		this.loading = true
		const res = await api.get('/api/blogging/content-tags')
		this.loading = false
		this.options.length = 0
		this.options.push(
			...res.data.map((option) => {
				Object.assign(option, { loading: false })
				return option
			}),
		)
		// @ts-ignore
		fuse = new Fuse(this.options, {
			keys: ['name'],
		})
	}

	clearForm() {
		this.form.id = ''
		this.form.name = ''
		this.form.desc = ''
		this.form.wp_id = ''
		this.modalLoading = false
	}

	openEdit(tag) {
		this.form.id = tag.id
		this.form.name = tag.name
		this.form.desc = tag.desc
		this.form.wp_id = tag.wp_id
		this.$bvModal.show('modal-edit-tag')
	}

	openNew() {
		this.clearForm()
		this.$bvModal.show('modal-new-tag')
	}

	async saveEdit() {
		const tag = this.options.find((tag) => tag.id === this.form.id)
		this.modalLoading = true
		const res = await api.post(
			'/api/blogging/content-tags/' + tag.id,
			this.form,
		)
		if (res.ok) {
			tag.name = this.form.name
			tag.desc = this.form.desc
			tag.wp_id = this.form.wp_id
			this.$bvModal.hide('modal-edit-tag')
			this.$bvToast.toast('Tag salva com sucesso!', {
				title: 'Sucesso!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'success',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			this.$bvToast.toast(res.msg, {
				title: 'Erro!',
				autoHideDelay: 5000,
				appendToast: true,
				variant: 'danger',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		}

		this.modalLoading = false
	}

	async saveNew() {
		this.modalLoading = true
		const res = await api.post('/api/blogging/content-tags/', this.form)
		if (res.ok) {
			this.options.push({
				id: res.data.id,
				name: this.form.name,
				desc: this.form.desc,
				wp_id: this.form.wp_id,
				loading: false,
			})

			// @ts-ignore
			fuse = new Fuse(this.options, {
				keys: ['name'],
			})

			this.$bvModal.hide('modal-new-tag')
			this.$bvToast.toast('Tag adicionada com sucesso!', {
				title: 'Sucesso!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'success',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			this.$bvToast.toast(res.msg, {
				title: 'Erro!',
				autoHideDelay: 5000,
				appendToast: true,
				variant: 'danger',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		}

		this.modalLoading = false
	}

	mounted() {
		this.init()
	}
}
